import React from 'react';
import { makeStyles } from '@mui/styles';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import { Icon, Tabs } from '@ts/storybook';
import RuleComponent from './Rule';
import RulesetIcons from './RulesetIcon';
import { Button, Grid, TextInput } from '@ts/storybook';
import { Theme } from '@mui/material';
import { IForm } from '@ts/ui-models';

const useStyles = makeStyles<Theme>(() => ({
  button: {
    margin: '8px',
  },
  leftIcon: {
    marginRight: '8px',
  },
  rightIcon: {
    marginLeft: '8px',
  },
  iconSmall: {
    fontSize: 20,
  },
  paperTitle: {
    marginLeft: '20px',
    marginTop: '20px',
  },
  flexGrow1: { flexGrow: 1 },
}));

const RULES = 'RULES';
const ICONS = 'ICONS';

interface IRulesetFormProps extends IForm {}

const FormRuleset = (props: IRulesetFormProps) => {
  const classStyle = useStyles();

  const { mode, values, onChange, onCallbackChange } = props;
  if (!values) return null;
  const [state, setState] = React.useState({
    activeTab: RULES,
  });
  const TABS = [
    { label: 'Rules', value: RULES },
    { label: 'Icons', value: ICONS },
  ];
  const isViewMode = mode === 'view';

  //#region Handlers
  const _onChangeRule = id => value => {
    const { rules } = props.values;
    const newRules = rules ? [...rules] : [];

    let findRule = false;
    newRules.forEach((rule, index) => {
      if (rule.id === id) {
        findRule = true;
        if (value.isAlive === false) newRules.splice(index, 1);
        else newRules[index] = value;
      }
    });
    if (!findRule) newRules.push(value);

    onChange('rules', newRules);
  };

  const onChangeIcons = icons => {
    onChange('actions', [icons]);
  };
  const onChangeTab = (event, tab) => setState({ activeTab: tab });
  //#endregion

  const _newRule = () => {
    const { rules } = props.values;
    const newRules = rules ? [...rules] : [];

    newRules.push({ id: uuidv4(), isEnabled: true, ruleTypeId: 'include' });
    onChange('rules', newRules);
  };

  //#region Render
  const renderTabContent = () => {
    const { activeTab } = state;
    if (activeTab === RULES) return renderRules();
    else if (activeTab === ICONS) return renderIcons();
  };

  const renderRules = () => {
    const { values, requiredFields } = props;

    if (!values) return null;

    const { name } = values;
    return (
      <Grid container spacing={2} className={classStyle.flexGrow1}>
        <Grid size={{ xs: 12 }}>
          <TextInput
            isReadOnly={isViewMode}
            label="Name"
            value={name}
            onChangeValue={onCallbackChange('name')}
            required={requiredFields.includes('name')}
            infoText="Blank spaces at the beggining and the end will be trimmed on save"
          />
        </Grid>
        <Grid size={{ xs: 12 }}>{_renderRules()}</Grid>
        <Grid size={{ xs: 12 }}>
          <Button
            size="small"
            className={classStyle.button}
            onClick={_newRule}
            disabled={isViewMode}
            startIcon={<Icon className={classStyle.leftIcon + ' ' + classStyle.iconSmall} icon="content-add" />}
            label="New Rule"
          />
        </Grid>
      </Grid>
    );
  };

  const _renderRules = () => {
    const { values } = props;
    const { rules } = values;

    return rules?.map((rule, index) => (
      <div key={index}>
        {index > 0 && <div>OR</div>}
        <RuleComponent disabled={isViewMode} key={`rule_${index}`} rule={rule} onChange={_onChangeRule(rule.id)} />
      </div>
    ));
  };

  const renderIcons = () => {
    const { values } = props;
    const { actions } = values;
    if (!actions) return;

    return <RulesetIcons disabled={isViewMode} action={actions[0]} onChange={onChangeIcons} />;
  };
  //#endregion

  return (
    <Tabs id={'ruleset-form'} tabs={TABS} value={state.activeTab} onChange={onChangeTab}>
      {renderTabContent()}
    </Tabs>
  );
};

export default FormRuleset;
